import { motion } from "framer-motion";

const STEPS = [
  {
    n: "01",
    title: "Portfolio Assessment",
    body: "We analyze your mature & tail-end brand portfolio to identify revenue opportunities and gaps in coverage.",
  },
  {
    n: "02",
    title: "Delta Force Deployment",
    body: "Trained young professionals from Tier 2–3 cities are mapped to target markets and brands.",
  },
  {
    n: "03",
    title: "3D Phygital Execution",
    body: "HCP Connect + Digital Connect + Channel Connect deliver complete brand engagement.",
  },
  {
    n: "04",
    title: "Performance-Based Results",
    body: "Revenue-sharing model aligns incentives — you pay for growth, not just effort.",
  },
];

export default function Process() {
  return (
    <section className="py-20 md:py-32 bg-slate-50 border-y border-slate-200" data-testid="process-section">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl mb-14 md:mb-20">
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-teal-700 mb-3">The Process</div>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-extrabold leading-[1.02] text-slate-900">
            4 steps to revitalize <br />
            <span className="font-editorial italic font-medium text-slate-700">your brands.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-slate-200">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.45, delay: i * 0.08 }}
              data-testid={`process-step-${i}`}
              className="bg-white p-8 md:p-10 flex flex-col h-full"
            >
              <div className="font-display font-extrabold text-5xl text-slate-200 tnum mb-8">{s.n}</div>
              <h3 className="font-display text-xl md:text-2xl font-bold text-slate-900 mb-3">{s.title}</h3>
              <p className="text-[15px] text-slate-600 leading-relaxed">{s.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
